module.exports = __webpack_public_path__ + "img/julio_feature_art_beta_4_1.2cf17799.svg";